// src/store/modules/device.js
import apiService from '@/services/api.service';

const state = {
  deviceDetails: {
    device: null,
    accessories: [],
    contacts: [],
    events: []
  },
  loading: false,
  error: null
};

const getters = {
  deviceDetails: state => state.deviceDetails,
  loading: state => state.loading,
  error: state => state.error
};

const actions = {
  async fetchDetails({ commit }, deviceId) {
    commit('setLoading', true);
    commit('clearError');
    try {
      const response = await apiService.getDeviceDetails(deviceId);
      commit('setDeviceDetails', response.data);
      return response.data;
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Erreur de chargement');
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async createDevice({ commit }, deviceData) {
    commit('setLoading', true);
    commit('clearError');
    try {
      const response = await apiService.createDevice(deviceData);
      return response.data;
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Erreur de création');
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async updateDevice({ commit }, { deviceId, deviceData }) {
    commit('setLoading', true);
    commit('clearError');
    try {
      const response = await apiService.updateDevice(deviceId, deviceData);
      return response.data;
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Erreur de mise à jour');
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteDevice({ commit }, deviceId) {
    commit('setLoading', true);
    commit('clearError');
    try {
      const response = await apiService.deleteDevice(deviceId);
      return response.data;
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Erreur de suppression');
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  // Contacts
  async addContact({ commit }, { deviceId, contactData }) {
    commit('setLoading', true);
    commit('clearError');
    try {
      const response = await apiService.createContact(deviceId, contactData);
      return response.data;
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Erreur ajout contact');
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async updateContact({ commit }, { deviceId, contactId, contactData }) {
    commit('setLoading', true);
    commit('clearError');
    try {
      const response = await apiService.updateContact(deviceId, contactId, contactData);
      return response.data;
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Erreur mise à jour contact');
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteContact({ commit }, { deviceId, contactId }) {
    commit('setLoading', true);
    commit('clearError');
    try {
      const response = await apiService.deleteContact(deviceId, contactId);
      return response.data;
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Erreur suppression contact');
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  // Commandes MQTT
  async sendCommand({ commit }, { deviceId, command, data }) {
    commit('setLoading', true);
    commit('clearError');
    try {
      const response = await apiService.sendCommand(deviceId, command, data);
      return response.data;
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Erreur envoi commande');
      throw error;
    } finally {
      commit('setLoading', false);
    }
  }
};

const mutations = {
  setDeviceDetails(state, details) {
    state.deviceDetails = details;
  },
  setLoading(state, status) {
    state.loading = status;
  },
  setError(state, error) {
    state.error = error;
  },
  clearError(state) {
    state.error = null;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
